module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9515_dark_grey.e516335f.jpg";